__turbopack_context__.v({
  "grid": "mediaLibraryPicker-module-scss-module__2tX2DW__grid",
  "pageBtn": "mediaLibraryPicker-module-scss-module__2tX2DW__pageBtn",
  "pageInfo": "mediaLibraryPicker-module-scss-module__2tX2DW__pageInfo",
  "pagination": "mediaLibraryPicker-module-scss-module__2tX2DW__pagination",
  "placeholder": "mediaLibraryPicker-module-scss-module__2tX2DW__placeholder",
  "tile": "mediaLibraryPicker-module-scss-module__2tX2DW__tile",
  "tile--selected": "mediaLibraryPicker-module-scss-module__2tX2DW__tile--selected",
  "tileCheck": "mediaLibraryPicker-module-scss-module__2tX2DW__tileCheck",
  "tileImage": "mediaLibraryPicker-module-scss-module__2tX2DW__tileImage",
});
